import type {Editor} from 'grapesjs';
import {escapeHTML} from '@Utils/string.util';

const CONTENTEDITABLE_SELECTOR = '[contenteditable="true"]';

/** Forces plain-text paste inside RTE-editable canvas elements. Returns a teardown. */
export function attachPasteAsTextListener(editor: Editor): () => void {
  const iframeBody: HTMLElement = editor.Canvas.getBody();

  const onPaste = (e: ClipboardEvent): void => {
    if (!(e.target instanceof Element) || !e.target.closest(CONTENTEDITABLE_SELECTOR)) {
      return;
    }

    e.stopPropagation();
    e.preventDefault();

    const text = e.clipboardData?.getData('text');

    if (text) {
      const formattedData = escapeHTML(text).replace(/(\r\n|\n|\r)/g, '<br>');
      // insertHTML inside the GrapesJS RTE has no non-deprecated equivalent.
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      e.target.ownerDocument.execCommand('insertHTML', false, formattedData);

      const component = editor.getSelected();
      if (component) {
        editor.trigger('component:update', component);
      }
    }
  };

  iframeBody.addEventListener('paste', onPaste);

  return (): void => {
    iframeBody.removeEventListener('paste', onPaste);
  };
}
